import { Suspense, lazy } from 'react';
import { Provider } from 'react-redux';
import { ConfigProvider, App as AntApp } from 'antd';
import StandaloneChecker from 'components/helpers/StandaloneChecker';
import ConfirmationModal from 'features/confirmationModal';
import SessionVerifier from 'features/sessionVerifier';
import Loader from 'components/helpers/Loader';
import MainRouter from 'pages/routers/Main';
import LoginRouter from 'pages/routers/Login';
import { antThemeLight } from 'assets/antTheme';
import store, { LINKS } from './configuration';

const OAuth = lazy(() => import('./pages/OAuth'));
const CookieNotice = lazy(() =>
  import('components/helpers/CookieNotice').catch(() => ({ default: () => null }))
);

const standalones = [
  {
    path: LINKS.oauth,
    Comp: OAuth,
  },
];

function App() {
  const wrap = ({ children }) => (
    <StandaloneChecker standalones={standalones}>{children}</StandaloneChecker>
  );
  return (
    <ConfigProvider theme={antThemeLight}>
      <AntApp>
        <Suspense fallback={<Loader />}>
          <Provider store={store}>
            <SessionVerifier Main={MainRouter} Login={LoginRouter} Wrapper={wrap} />
            <ConfirmationModal isRedirectingToMain />
          </Provider>
          <CookieNotice />
        </Suspense>
      </AntApp>
    </ConfigProvider>
  );
}

export default App;
